var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuItem({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 1.99658C6 1.99658 4 15.9966 3 21.9966C3.66667 21.9966 4.33275 21.9966 4.99824 21.9966C5.66421 18.6635 7.33146 16.8302 10 16.4966C14 15.9966 17 12.4966 18 9.49658L16.5 8.49658C16.8333 8.16325 17.1667 7.82991 17.5 7.49658C18.5 6.49658 19.5042 4.99658 21 1.99658Z",
    fill: "#FFE360"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuItem);
export default __webpack_public_path__ + "static/media/menu-item.356909317f21ec1fe1b18256cf8d65c4.svg";
export { ForwardRef as ReactComponent };